/** @format — Silence MetaMask browser-extension errors on non-Web3 pages */

function metaMaskNoiseText(...parts) {
  return parts
    .flatMap((part) => {
      if (!part) return [];
      if (typeof part === "string") return [part];
      if (part instanceof Error) return [part.message, part.stack];
      if (typeof part === "object") return [part.message, part.stack, String(part)];
      return [String(part)];
    })
    .join(" ");
}

export function isMetaMaskExtensionNoise(...parts) {
  const haystack = metaMaskNoiseText(...parts);
  return /metamask|nkbihfbeogaeaoehlefnkodbefgpgknn|inpage\.js|failed to connect to metamask/i.test(
    haystack,
  );
}

export function suppressMetaMaskExtensionNoise() {
  if (typeof window === "undefined" || window.__dockieMetaMaskNoiseSuppressed) return;
  window.__dockieMetaMaskNoiseSuppressed = true;

  window.addEventListener(
    "unhandledrejection",
    (event) => {
      if (!isMetaMaskExtensionNoise(event.reason, event.reason?.stack)) return;
      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true,
  );

  window.addEventListener(
    "error",
    (event) => {
      if (
        !isMetaMaskExtensionNoise(
          event.message,
          event.filename,
          event.error,
          event.error?.stack,
        )
      ) {
        return;
      }
      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true,
  );
}

suppressMetaMaskExtensionNoise();
